import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d20d9a0c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=d20d9a0c&prod&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=d20d9a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20d9a0c",
  null
  
)

export default component.exports